import React from 'react'
import { Badge, Icon } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

//new, pending, error, success
const STATUSES = {
  new: {
    icon: 'status active',
    color: 'Label-Confirm',
    bgColor: 'Background-Confirm',
    label: 'accounts_marketplace::category.list.badges.new',
  },
  pending: {
    icon: 'time-clock',
    color: 'Label-Notice',
    bgColor: 'Background-Notice',
    label: 'accounts_marketplace::category.list.badges.pending',
  },
  error: {
    icon: 'status warning',
    color: 'Label-Error-Primary',
    bgColor: 'Background-Error',
    label: 'accounts_marketplace::category.list.badges.error',
  },
  success: {
    icon: 'status active',
    color: 'Label-Confirm',
    bgColor: 'Background-Confirm',
    label: 'accounts_marketplace::category.list.badges.success',
  },
}

export const StatusBadge = ({ status = null, ...rest }) => {
  const currentStatus = STATUSES?.[status]
  const { t } = useTranslation()

  if (!currentStatus) {
    return null
  }

  const { icon, label, bgColor, color } = currentStatus

  return (
    <Badge
      variant={'Body-10'}
      noWrap
      {...rest}
      size={'xs'}
      bgColor={bgColor}
      color={color}
      startIcon={<Icon color={color} name={icon} width={16} />}
    >
      {t(label)}
    </Badge>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.elementType,
}
